import { render, staticRenderFns } from "./BodyOrderView.vue?vue&type=template&id=0976acc4&scoped=true&"
import script from "./BodyOrderView.vue?vue&type=script&lang=js&"
export * from "./BodyOrderView.vue?vue&type=script&lang=js&"
import style0 from "./BodyOrderView.vue?vue&type=style&index=0&id=0976acc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976acc4",
  null
  
)

export default component.exports